<template>
    <div class="dashboard">
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    created() {
    },
    mounted() {
    },
    methods: {},
};
</script>
